<template>
  <div class="app-container">
    <!-- <el-row :gutter="20">
      <el-col :span="6">
        <el-tree
          :data="treeData"
          ref="tree"
          default-expand-all
          node-key="id"
          :expand-on-click-node="false"
          highlight-current
          
          :props="defaultProps"
          @node-click="handleNodeClick"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-col>
      
    </el-row> -->
    <el-button
      size="medium"
      v-if="roles.includes('/equipment/type_add')"
      type="primary"
      style="font-size: 14px; cursor: pointer"
      @click="addType({ id: 0, level: 0 })"
      >添加</el-button
    >

    <el-table
      max-height="700"  v-loading="listLoading" 
      :data="list"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column label="序号" min-width="120">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="设备类型名称" min-width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="设备类型编码" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.code }}
        </template>
      </el-table-column>
      <el-table-column label="位置描述" min-width="110" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.position }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="210" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            v-if="roles.includes('/equipment/type_add')"
            @click="addType(scope.row)"
            >添加</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/equipment/type_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/equipment/type_del')"
            >删除</el-button
          >
          <!-- <el-button
                size="mini"
                type="primary"
                @click="relevance(scope.row)"
                v-if="
                  roles.includes('/maintenance/set_type_role') && treeId != 0
                "
                >关联角色</el-button
              > -->
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      size="700px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="园区" prop="park_id" v-if="ruleForm.type != 3">
          <el-select filterable 
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            disabled
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="设备类型名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            :disabled="cztype == 'see'"
            placeholder="请输入设备类型名称"
            @blur="changeName"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="设施名称首字母缩写" prop="name_acronyms">
          <el-input
            v-model="ruleForm.name_acronyms"
            placeholder="设施名称首字母缩写"
            disabled
          ></el-input>
        </el-form-item> -->
        <el-form-item label="设备类型编码" prop="code">
          <el-input
            v-model="ruleForm.code"
            disabled
            placeholder="请输入设备类型编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="层级" prop="level">
          <el-input
            class="numInput"
            type="number"
            v-model="ruleForm.level"
            disabled
            placeholder="请输入层级"
          ></el-input>
        </el-form-item>
        <el-form-item label="特定类型" prop="special">
          <el-radio-group v-model="ruleForm.special" :disabled="cztype == 'see'">
            <el-radio :label="0">普通</el-radio>
            <el-radio :label="1">电梯</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="位置描述" prop="position">
          <el-input
            type="textarea"
            v-model="ruleForm.position"
            :disabled="cztype == 'see'"
            placeholder="请输入位置描述"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            保存
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { pinyin } from "pinyin-pro";
import { mapGetters } from "vuex";
import { openPark } from "@/api/index";
import { delImage } from "@/api/index";
import { TypeList, addType, editType, delType, seeType } from "@/api/facility";
import { getToken } from "@/utils/auth";
import treeTransfer from "el-tree-transfer";
import SelectTree from "@/components/treeSelect/treeSelect.vue";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  components: { treeTransfer, SelectTree },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      curren: "0",
      treeData: [
        {
          name: "园区管理",
          id: 0,
          children: [],
        },
      ],
      selectList: [
        {
          id: 0,
          title: "工单类型",
        },
      ],
      props: {
        // 配置项（必选）
        value: "id",
        label: "title",
        children: "nodes",
        // disabled:true
      },
      treeId: 0,
      defaultProps: {
        children: "children",
        label: "name",
      },
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加设备类型",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        is_page: 2,
        is_tree: 2,
      },
      parkList: [],
      ruleForm: {
        title: "",
        is_overdue: 1,
        is_hardware: 2,
        response_time: { day: 0, hour: 0, minute: 0 },
        processing_time: { day: 0, hour: 0, minute: 0 },
        status: 1,
      },
      rules: {
        name: [
          { required: true, message: "请输入设备类型名称", trigger: "blur" },
        ],
        name_acronyms: [
          {
            required: true,
            message: "请输入设备类型名称首字母缩写",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "请输入设备类型编码", trigger: "blur" },
        ],
        level: [{ required: true, message: "请输入层级", trigger: "blur" }],
        park_id: [{ required: true, message: "请选择园区" }],
      },
      multipleSelection: [],
      cztype: "",
      oldImg: "",
      qxId: "",
      roleList: [],
      oldCode: "",
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.curren = this.userInfo.park_id;
      this.treeId = this.userInfo.park_id;
      this.screen.park_id = this.userInfo.park_id;
      this.screen.type = this.userInfo.type;
    } else {
      this.curren = "0";
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getpark();
  },
  methods: {
    changeName(e) {
      var that = this;
      const nameList = pinyin(this.ruleForm.name, {
        pattern: "first",
        toneType: "none",
        type: "array",
      })
        .join("")
        .toUpperCase();
      that.ruleForm.name_acronyms = nameList;
      if (that.ruleForm.pid == 0) {
        // var parkName = ''
        // this.treeData[0].children.forEach((item,index)=>{
        //   if(that.treeId == item.id){
        //     return parkName = item.name
        //   }
        // })
        // const park = pinyin(parkName,{ pattern: 'first', toneType: 'none', type: 'array' }).join('').toUpperCase()
        that.ruleForm.code = nameList;
      } else {
        that.ruleForm.code = that.oldCode + "-" + nameList;
      }
    },
    getValue(value) {
      this.ruleForm.pid = value;
    },
    handleNodeClick(data) {
      this.treeId = data.id;
      this.screen.park_id = data.id;
      this.fetchData();
    },

    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              editType(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.getInfo(val.id);
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.getInfo(val.id);
      // this.ruleForm = val
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          delType({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    getInfo(id) {
      seeType({ id: id }).then((res) => {
        this.ruleForm = {
          pid: res.data.info.pid,
          name: res.data.info.name,
          name_acronyms: res.data.info.name_acronyms,
          code: res.data.info.code,
          park_id: res.data.info.park_id,
          level: res.data.info.level,
          position: res.data.info.position,
          id: res.data.info.id,
          special:res.data.info.special
        };
        let code = res.data.info.code.split("-");
        code.pop();
        this.oldCode = code.join("-");
        // this.code = res.data.info.code.split()
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      // addType
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = JSON.parse(JSON.stringify(that.ruleForm));
          // data.processing_time = this.globalfunc.swapMinute(
          //   data.processing_time
          // );
          // data.response_time = this.globalfunc.swapMinute(data.response_time);
          this.$confirm("确认提交？")
            .then(() => {
              addType(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addType(data) {
      this.drawerTitle = "添加设备类型";
      this.cztype = "add";
      this.ruleForm = {
        pid: data.id,
        name: "",
        name_acronyms: "",
        code: data.code ? data.code : "",
        park_id: this.treeId,
        level: data.level + 1,
        position: "",
        special:0
      };
      this.oldCode = data.code;
      this.drawer = true;
    },
    getpark() {
      openPark({ id: this.treeId, is_page: 2, status: 1 }).then((res) => {
        this.treeData[0].children = res.data.lists;
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      TypeList(this.screen).then((response) => {
        this.list = response.data.lists;
        this.selectList = this.selectList.concat(response.data.list);
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
::v-deep .el-tree-node__content {
  height: auto !important;
}
::v-deep .custom-tree-node {
  font-size: 16px !important;
  line-height: 40px !important;
}
.table-box {
  margin-top: 20px;
}

.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}

.tableIcon {
  width: 50px;
  height: 50px;
}

.screenInput {
  width: 200px;
  margin: 0 10px;
}

.dialog-footer {
  text-align: center;
}

::v-deep .transfer-title {
  margin: 0;
}

::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}

::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  color: rgb(64, 158, 255);
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  .el-button--text {
    color: #ccc !important;
  }
}

::v-deep .formItem {
  .el-form-item__label {
    width: 0 !important;
    float: none !important;
  }

  .el-form-item__content {
    margin: 0 !important;
  }
}

::v-deep .el-tree-node__content {
  position: relative;
  .disabled {
    cursor: not-allowed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
  }
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
